// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__T4z0Q","inner":"Tab_inner__NOvtw","items":"Tab_items__Jd4sV","isActive":"Tab_isActive__CamWJ","tabs":"Tab_tabs__F9i2F"};